import React from "react";
import {
  DetailMSSName,
  LabelDetail,
} from "../../../../component/page-components/detail";
import useDetailDataGroup from "./detail-data-group.hooks";

const DataScope = () => {
  const { data } = useDetailDataGroup();

  return (
    <>
      <div className=" mt-10 flex flex-col">
        <div className=" mt-3 flex flex-row">
          <div className=" w-96">
            <LabelDetail children="Depot ID" />
            <DetailMSSName
              data={data?.scope_depot_id ? data?.scope_depot_id : null}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DataScope;
